import { render, staticRenderFns } from "./CoreInfoCard.vue?vue&type=template&id=2dc25066"
import script from "./CoreInfoCard.vue?vue&type=script&lang=js"
export * from "./CoreInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports